import { getToken } from '../utils/auth';

import { API_BASE_URL } from './URL_Header';

export const fetchTypes = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/GetAllTypes`);
    if (!response.ok) throw new Error('Failed to fetch types');
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchTypeById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/GetType/${id}`);
    if (!response.ok) throw new Error('Failed to fetch type');
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchTypeNameById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/GetTypeName/${id}`);
    if (!response.ok) throw new Error('Failed to fetch type name');
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const createType = async (type) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/AddType`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`
      },
      body: JSON.stringify({
        ...type,
        Sales: 0,
        IsAvailable: true // Default to available
      })
    });
    if (!response.ok) throw new Error('Failed to create type');
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const updateType = async (id, type) => {
  try {
    // Ensure the ID is included in the type object
    const typeWithId = {
      ...type,
      typeId: id
    };
    
    console.log("Sending update request with payload:", typeWithId); // Debug log
    
    const response = await fetch(`${API_BASE_URL}/Type/EditType/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`
      },
      body: JSON.stringify(typeWithId)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error("Update failed with status:", response.status, "Response:", errorText);
      throw new Error(`Failed to update type: ${response.status}`);
    }
    
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    console.error("UpdateType API error:", err);
    throw new Error(err.message);
  }
};

export const deleteType = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/DeleteType/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${getToken()}`
      }
    });
    if (!response.ok) throw new Error('Failed to delete type');
    return response.status === 204 ? {} : await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchTypeIdByName = async (name) => {
  try {
    const response = await fetch(`${API_BASE_URL}/Type/GetTypeIdByName/${encodeURIComponent(name)}`);
    if (!response.ok) throw new Error('Failed to fetch type ID');
    return await response.json();
  } catch (err) {
    throw new Error(err.message);
  }
};